import type { NavItem } from '../../../../_metronic/helpers/utils/types';

export const financialLiteracyData: NavItem[] = [
  {
    label: 'About',
    to: '/pages/financialLiteracy/about'
  },
  {
    label: 'Documentation',
    to: '/pages/financialLiteracy/documentation'
  },
  {
    label: 'Terms',
    to: '/pages/financialLiteracy/terms'
  },
  {
    label: 'Process',
    to: '/pages/financialLiteracy/process'
  },
  {
    label: 'Stats',
    to: '/pages/financialLiteracy/stats'
  }
];
